import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DashboardService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getBlocks(gridData = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/dashboard/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getSuppliers() {
    return this.http.get<any>(environment.apiUrl + '/dealer-system/dashboard/suppliers')
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
